export { useReducedMotion } from '@wp-g2/create-styles';